module.exports = __webpack_public_path__ + "img/single_pictures_9.63d796ec.jpg";